module.exports = __webpack_public_path__ + "static/img/posterLogo.9d8fc82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posterLogo.jpg
// module id = cOIc
// module chunks = 1